import React, { useEffect, useContext } from 'react'
import { func, string } from 'prop-types'
import emojiStrip from 'emoji-strip'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import StepBack from 'components/buy/Engraving/StepBack'
import Fieldset from 'components/Fieldset/index'
import FieldsetItem from 'components/Fieldset/FieldsetItem'
import Input from 'components/Input'
import Label from 'components/Label'
import { SelectOption } from 'components/buy/Engraving/EngravingComponents'
import EngravingOption from 'components/buy/Engraving/EngravingOption'
import List from 'components/buy/Engraving/List'
import Tabs from 'components/buy/Engraving/Tabs'

const Text = ({ item, setStep }) => {
  const { engraving, setEngraving, currentView, setCurrentView, textError } = useContext(EngravingContext)
  const MAX_LENGTH = engraving[item].text.orientation === 'horizontal' ? 3 : 10

  useEffect(() => {
    setCurrentView({ ...currentView, item: item, step: 'text' })
  }, [])

  const fonts = [
    'Abebedera',
    'Ahamono',
    'Arabella',
    'Droid',
    'Fusterd',
    'Honeyscript',
    'Indonesian',
    'Le Murmure',
    'Monument',
    'Neo Writer'
  ]

  const updateEngraving = prop => {
    setEngraving({
      ...engraving,
      [item]: {
        ...engraving[item],
        text: {
          ...engraving[item].text,
          ...prop
        }
      }
    })
  }

  return (
    <>
      <Heading
        title="Add text to your device"
        back={() => <StepBack setStep={setStep} initialstep={'initialstep'} />}
      />
      <Fieldset>
        <FieldsetItem xs="1-1">
          <Label>Pick your text direction</Label>
          <Tabs>
            <SelectOption
              onClick={() => {
                updateEngraving({ orientation: 'horizontal' })
              }}
              selected={engraving[item].text.orientation === 'horizontal'}
            >
              Horizontal
            </SelectOption>
            <SelectOption
              onClick={() => {
                updateEngraving({ orientation: 'vertical' })
              }}
              selected={engraving[item].text.orientation === 'vertical'}
            >
              Vertical
            </SelectOption>
          </Tabs>
        </FieldsetItem>

        <FieldsetItem xs="1-1">
          <Input
            label="Enter your text"
            name="text"
            type="text"
            value={engraving[item].text.value}
            onChange={e => {
              updateEngraving({
                value: emojiStrip(e.target.value)
              })
            }}
            maxLength={MAX_LENGTH}
            hint={`Add up to ${MAX_LENGTH} characters-go ahead, express yourself.`}
            meta={{
              error: textError,
              touched: textError.length > 0
            }}
            placeholder="Abc"
          />
        </FieldsetItem>

        <FieldsetItem xs="1-1">
          <List row={4}>
            {fonts.map((font, idx) => (
              <EngravingOption
                key={idx}
                selected={engraving[item].text.font === font}
                onClick={() => {
                  updateEngraving({ font: font })
                }}
                text="ABC"
                fontFamily={font}
                name={font}
              />
            ))}
          </List>
        </FieldsetItem>
      </Fieldset>
    </>
  )
}

Text.propTypes = {
  setStep: func.isRequired,
  item: string.isRequired
}

export default Text
